<script>
    import * as Sentry from '@sentry/svelte';
    import 'maplibre-gl/dist/maplibre-gl.css';
    import maplibregl from 'maplibre-gl';
    import * as pmtiles from 'pmtiles';

    import { onMount, onDestroy, mount } from 'svelte';
    import { browser } from '$app/environment';
    import { hapticsImpactMedium } from '$lib/haptics.js'

    //import { unp_json } from '$lib/static/unp_json.js'
    import { PUBLIC_BORDERS_SRC, PUBLIC_REGIONS_MAX_ZOOM } from '$env/static/public';
    import { js, get_region_by_id } from '$lib/app/static.js';
    import { is_natural, is_osm_uid, jsonDeepEqual } from '$lib/universal/lib.js'
    import { map_disable_rotation, button_disable, button_enable,
        city_search_success_function, find_user_bounds, server_name,
        handleFetch, handleFetchReject, handle_fetch,
        map_settings_add_defaults, map_style_url } from '$lib/app/lib.js';
//    import { handleFetch, handleFetchReject, 
//        map_settings_add_defaults, map_style_url } from '$lib/lib.js';
    import { toggle_visit } from '$lib/app/lib.js';
    import { computePosition, flip, shift, offset } from '@floating-ui/dom';
    import { tooltip, createVirtualElement } from './tooltip.js';
    import { get_osm_uid_state } from '$lib/app/activeUserData.svelte.js';
    import BeenButton from "./BeenButton.svelte";
    import BeenControl from "./BeenControl.svelte";

    // Type of map:
    //      'user'  (/user/xxx)
    //      'add' (/mymap/add)
    //      'usermap' (/usermap/xxx)
    let {
        map_id = null,
        type = 'user',
        userpage, // me?
        token, // cookie
        map = $bindable(),
        user_data,
        width,
        height,
        on_moveend_func = null, // capacitor only??
        on_moveend_search = $bindable(undefined),
        map_covered = 0,
        secret = null,
        selectedRegIntId = $bindable(),
        selectedRegType = $bindable(),
        map_settings_override = $bindable({}),
        capacitor,
        disable_map_on_movened = $bindable(),
    } = $props();


    let map_loading = $state(true);
    let typeAllowsEdits = (type === 'user' || type === 'add');
    let active_userpage = undefined;
    let active_map_settings = {};
    let active_editable = $state();
    let geolocate_control = null;

    if(!map_id) {
        throw new Error('map_id not set');
    }

    let map_settings = $derived(map_settings_add_defaults(user_data?.map_settings, map_settings_override));

    let regFilterExpr = $derived.by(() => {
        return map_settings["highlight-countries"] == 'tcc' ? ['all', ['==', 'T', 1], ['in', 'reg'].concat(Object.keys(user_data?.stats?.tcc ?? [])) ] :
            map_settings["highlight-countries"] == 'reg' ? ['all', ['==', 'R', 1], ['in', 'reg'].concat(Object.keys(user_data?.stats?.reg ?? [])) ] :
            ['in', 'reg'].concat(Object.keys(user_data?.stats?.unp ?? []));
    });

    //$inspect('regFilterExpr=' + JSON.stringify(regFilterExpr));

    let borderFilterExpr = $derived.by(() => {
        return (active_editable && map_settings?.['region-borders'] == 'all') ? ['==', 'R', 1] : regFilterExpr;
    });

    //$inspect('borderFilterExpr=' + JSON.stringify(borderFilterExpr));



    $effect(()=>{
        if(map && map.getLayer('beenEW_regions')) {
            map.setFilter('beenEW_regions', regFilterExpr);
            if(map.getLayer('beenEW_region-borders')) {
                map.setFilter('beenEW_region-borders', borderFilterExpr);
                map.setPaintProperty('beenEW_region-borders', 'line-color', getBorderColor(map_settings));
            }
            let paintExpression = makePaintExpression(user_data, map_settings);
            map.setPaintProperty('beenEW_regions', 'fill-color', paintExpression['fill-color']);
            map.setPaintProperty('beenEW_regions', 'fill-opacity', paintExpression['fill-opacity']);
        } else {
            regFilterExpr;
        }
    });

    let style = $state(is_natural(width) && is_natural(height) ? `width:${width}px !important; height:${height}px !important;` : ``);

    $effect(() => {
        if(is_natural(width) && is_natural(height)) {
            style =  `width:${width}px !important; height:${height}px !important;`;
            if(map) {
                map.once('idle',function(){
                    map.resize();
                })
            }
        }
    });

    $effect(() => { module_map = map });

    $effect(() => { module_capacitor = capacitor });

    $effect(() => {
        map_apply_settings(user_data, map_settings_override);
    });

    $effect(() => {
        if(map) {
            if(on_moveend_func || on_moveend_search) {
                map_on_movened();
                map.on('moveend', map_on_movened);
            } else {
                map.off('moveend', map_on_movened);
            }
        }
    });

    onDestroy(() => {
        if(map) {
            if(!browser) {
                Sentry.captureMessage("PROBLEM: map is not null on the server");
            }
            map.remove();
            map = null;
            active_map_settings = {};
        }
    });

    onMount(() => {
        if(!browser) 
            Sentry.captureMessage("PROBLEM: onMount runs NOT in browser");

        ///if(!document.getElementById('map'))
        ///    console.log("PROBLEM: no #map selector!");
        
        if(map)
            Sentry.captureMessage("PROBLEM: Map not null in onMount!");

        // add the PMTiles plugin to the maplibregl global.
        const protocol = new pmtiles.Protocol();
        maplibregl.addProtocol('pmtiles', protocol.tile);

        if (maplibregl.getRTLTextPluginStatus() !== 'loaded' && maplibregl.getRTLTextPluginStatus() !== 'deferred') {
            maplibregl.setRTLTextPlugin(
                '/mapbox-gl-rtl-text.js',
                true // Lazy load the plugin
            );
        }


        const map_options = {
            //maxZoom: +PUBLIC_MAP_MAX_ZOOM,
            container: map_id, // container id
            ///style: map_style_url(map_settings_add_defaults(map_settings).style),
            style: map_style_url(map_settings_add_defaults(user_data?.map_settings).style),  /// WHY DID WE NEED let map_settings?
            ///maxZoom: map_settings['maxZoom'], 

            /*worker: false,
            transformRequest: function(url, resourceType) {
                if (resourceType === 'Source' && url.indexOf('http://myHost') > -1) {
                    return {
                        url,
                        cache: 'force-cache',
                    }
                }
            }*/
        };

        let initial_bounds;

        if(user_data?.map_settings && user_data.map_settings?.zoom && user_data.map_settings?.center) {
            map_options.center = user_data.map_settings.center;
            map_options.zoom = user_data.map_settings.zoom;
        } else {
            initial_bounds = find_user_bounds(user_data?.map_settings, user_data);
            map_options.bounds = initial_bounds;
        }

        if(type === 'usermap' || type === 'share') {
            map_options.customAttribution = `&copy; <a href="${server_name('/user/' + userpage)}" target=_blank>BeenEverywhere</a>`;
            if(type === 'share' && import.meta.env.DEV) {
                // to make 128x128 icons
            } else {
                map_options.dragPan = false;
            }
        }

        /*
        if(type === 'user') {
            const mapContainter = document.getElementById(map_id);
            new ResizeObserver(() => { console.log(mapContainter.offsetHeight)} ).observe(mapContainter);
        }
        */

        //const cachingPlugin = new CacheRequestsPlugin();

        map = new maplibregl.Map(map_options);
        //cachingPlugin.apply(map);

        //map = new Map(map_options);
        ///active_map_settings.map_style = map_settings_add_defaults(map_settings).style;
        active_map_settings.style = map_settings_add_defaults(user_data?.map_settings).style;   /// WHY DID WE NEED let map_settings?
        active_map_settings.bbox = initial_bounds; // !!! it is bbox, not view&&map_bounds, because view&&map_bounds != bbox when view == 'been' !!!

        geolocate_control = new maplibregl.GeolocateControl({
        //geolocate_control = new GeolocateControl({
                        positionOptions: { enableHighAccuracy: true },
                        trackUserLocation: true,
                        fitBoundsOptions: { maxZoom: 14 }});
/*
        (active_map_settings?.view != settings?.view || 
            active_map_settings?.map_bounds?.[0]?.[0] != settings?.map_bounds?.[0]?.[0]         
*/
        
        map.on('load', () => {

            map_disable_rotation(map);

            //map.addControl(new maplibregl.ScaleControl({ maxWidth: 80 }), 'bottom-right');

            //!!!if(document.getElementById("map-style-form")) 
            //!!!    process_map_style_form();
            //!!!else             
            ///map_settings.editable = ($session?.id === $user_data?.profile?.id);  /// WHY DID WE NEED let map_settings?
            ///$user_data.map_settings.editable = (session?.id == $user_data?.profile?.id);
            //?!!map_apply_settings(map, $user_data, map_settings); 
            ///console.log("calling map_apply_settings from map.on('load')");
            map_apply_settings(user_data, map_settings_override);
            ///console.log("map_apply_settings - finish");

            /*
            if(user_data.profile?.id === user_visits?.user_id && 0 == (user_visits?.stats?.places_visited ?? 0)) {
                mapDisplayMessage({map, msg: 'Zoom in and click labels to add cities'});
            }
            */

            if(active_editable && !user_data?.stats?.places_visited && type != 'add') {
                mapDisplayMessage({map, msg: 'Zoom in and click labels to add cities. Your visited countries will update automatically'});
            }

            // Collapse attribution
            setTimeout(() => {
                let compact_show_el = document.getElementsByClassName('maplibregl-compact-show');
                if(compact_show_el?.[0]?.classList) {
                        compact_show_el[0].classList.remove('maplibregl-compact-show');
                }
            }, 750);

            map_loading = false;

            // Show the map's zoom level on DEV
            if(type === 'user') {
                if(import.meta.env.DEV && document.getElementById('zoom_level')) {
                    map.on('zoom', () => {
                        const zoom_level_div = document.getElementById('zoom_level');
                        if(zoom_level_div) {
                            zoom_level_div.innerHTML = 'Zoom: '+map.getZoom();
                        }
                    });
                }
            }

            if(type === 'usermap' || type === 'share') {
                if(type === 'share' && import.meta.env.DEV) {
                    // to make 128x128 icons
                } else {
                    map.getCanvas().style.cursor = 'pointer';
                    map.scrollZoom.disable();
                    map.doubleClickZoom.disable();
                }
            }

            if(type === 'usermap') {
                map.once('idle',function(){
                    let marker_div = document.createElement('div');
                    marker_div.setAttribute("id", "map-finished-loading");
                    document.body.appendChild(marker_div);
                });

                //map.getCanvas().style.cursor = 'pointer';
                //map.scrollZoom.disable();

                map.on('click', (e) => {
                    //console.log("click on map");
                    Sentry.captureMessage(`Click on an embedded map`, { extra: { userpage } });
                    window.open(server_name('/user/' + userpage), "_blank");
                });
            }
        });

        /*} else {
            console.log("\$map exists. calling map_apply_settings()...");
            map_apply_settings($map, $user_data, map_settings); 
            document.getElementById("map").classList.remove("map-loading");

        }



        //!!!{$add_first_city_js}
        //!!!{$map_edit_controls}
        */

    });


    function a_or_an(following) {
        if(following) {
            switch (following.charAt(0).toLowerCase()) {
                case 'a':
                case 'e':
                case 'i':
                case 'o':
                case 'u':
                    return 'an';
                default:
                    return 'a';
            }
        } else {
            return '';
        }
    }

/*
var default_colors = ['00F6FF', '0090FF', '000CFF', '9000FF'];
#00F6FF - был
#0090FF - кое-что видел
#000CFF - много где побывал
#9000FF - исходил вдоль и поперёк
*/
    function makePaintExpression(user_data, map_settings) {
        //console.log(`makePaintExpression(${JSON.stringify(map_settings)})`);
        let colorExpression = ['match', ['get', 'unp']];
        let opacityExpression = ['match', ['get', 'unp']];

        if(map_settings?.["highlight-color"] === 'choropleth') {
            // Build a GL match expression that defines the color for every vector tile feature
            // Use the UNP code as the lookup key for the country shape

            if(user_data?.stats?.unp_reg) {
                for (const unp in (user_data.stats.unp_reg)) {
                    switch(user_data.stats.unp_reg[unp]) {
                        case 1:
                            colorExpression.push(unp, '#00F6FF' /*'#00FFFF' /*'rgba(0, 255, 255, 0.3)' /* '#00F6FF'*/);
                            opacityExpression.push(unp, 0.1);
                            break;
                        case 2:
                            colorExpression.push(unp, '#0090FF' /*'#30A4FF' /*'rgba(0, 200, 200, 0.50)' /*'#3FAAFD'*/);
                            opacityExpression.push(unp, 0.2);
                            break;
                        case 3:
                            colorExpression.push(unp, '#000CFF' /*'#6052FF' /*'rgba(0, 0, 255, 0.7)' /*'#0000FF'*/);
                            opacityExpression.push(unp, 0.25);
                            break;
                        case 4:
                            colorExpression.push(unp, '#9000FF' /*'rgba(80, 0, 140, 1)' /*'#9000FF'*/);
                            opacityExpression.push(unp, 0.35);
                            break;
                    }

                }
                colorExpression.push('rgba(0, 0, 0, 0)'); // Invisible, to avoid blinking when 1 point visited in country is already level >1
                opacityExpression.push(0);
            } else {
                Sentry.captureMessage("makePaintExpression: No user_data?.stats?.unp_reg");
            }
        } else if(map_settings?.["highlight-color"] === 'political') {

            if(user_data?.stats?.unp) {
                for (const unp in (user_data.stats.unp)) {
                    //console.log(JSON.stringify(unp), $user_data.stats.unp[unp]);

                    if(user_data.stats.unp[unp] > 0) {
                        let un = js.unp_json?.[unp]?.dependent ?? unp;
                        switch(un) {
                            //#bd33a4
                            //
                            // Византийский цвет?

                            case 'OM':
                            case 'KH':
                            case 'BF': // Burkina Faso
                            case 'HN': // Honduras
                                opacityExpression.push(unp, 0.3);

                            case 'AR':
                            case 'SO':
                            case 'PK':
                            case 'BD':
                            case 'CI':
                            case 'BG':
                                colorExpression.push(unp, '#03c03c');
                                break;

                            case 'UY':
                            case 'CU':
                            case 'NO':
                                colorExpression.push(unp, '#FF7F00');
                                break;

                            case 'PY':
                                colorExpression.push(unp, '#FF0000');
                                break;

                            case 'GT':
                            case 'ZW': // Zimbabwe
                            case 'EC':
                            case 'TG': // Togo
                                colorExpression.push(unp, '#FF12C4');
                                break;

                            case 'JP':
                                opacityExpression.push(unp, 0.3);
                            case 'FR':
                            case 'NP':   // Nepal
                            case 'GM':   // Gambia
                                colorExpression.push(unp, '#9900FF');
                                break;

                            case 'LU':
                            case 'RU':
                            case 'RS':
                            case 'IS':
                            case 'TM':
                            case 'BH':
                            case 'DJ':
                                colorExpression.push(unp, '#FF0000');
                                break;

                            case 'SB':
                            case 'CH':
                            case 'ER': // Eritrea
                            case 'MR': // Mauritania
                            case 'BZ': // Belize
                            case 'KN': // Kitts and Nevis
                                colorExpression.push(unp, '#262626');
                                break;

                            case 'DE':
                            case 'BW':
                            case 'BO':
                                colorExpression.push(unp, '#777777'); // '#555555'
                                break;

                            case 'BS':
                            case 'TV':
                                opacityExpression.push(unp, 0.4);
                                colorExpression.push(unp, '#FFFFFF');
                                break;

                            case 'PT':
                            case 'UG':
                            case 'GH': // Ghana
                            case 'KG':
                            case 'BT':
                            case 'SV': // Salvador
                            case 'JM':
                                opacityExpression.push(unp, 0.35);
                            case 'TO':
                            case 'KZ':
                            case 'CR': // Costa Rica
                            case 'IR':
                            case 'BA':
                            case 'EG':
                            case 'MM':
                            case 'ML': // Mali
                            case 'CM': // Cameroon
                                colorExpression.push(unp, '#964B00');
                                break;

                            case 'BR':
                            case 'KE':
                            case 'ZA':
                            case 'SN':  // Senegal
                                colorExpression.push(unp, '#BB7C23');
                                break;

                            case 'AM':
                            case 'MG':
                            case 'IN': // India
                            case 'KW':
                            case 'PG':
                            case 'EH': // Western Sahara
                            case 'LY':
                            case 'VE': // Venezuela
                                opacityExpression.push(unp, 0.30);
                            case 'NG': // Nigeria
                                colorExpression.push(unp, '#FF7700');
                                break;

                            case 'TH':
                            case 'AE':
                                opacityExpression.push(unp, 0.35);
                            case 'DZ':
                            case 'CN':
                            case 'LK':
                            case 'UZ':
                            case 'NA':
                            case 'IQ':
                                colorExpression.push(unp, '#FFD939');
                                break;

                            case 'GB':
                                opacityExpression.push(unp, 0.35);
                                colorExpression.push(unp, '#007F00');
                                break;

                            case 'SA':
                            case 'CA':
                            case 'PL':
                            case 'CV': // Cabo Verde
                            case 'BJ': // Benin
                                colorExpression.push(unp, '#007F00');
                                break;

                            case 'NZ':
                                colorExpression.push(unp, '#00AF00');
                                break;

                            case 'AZ':
                                opacityExpression.push(unp, 0.3);
                            case 'AL':
                            case 'CO':
                            case 'TR':
                            case 'MY':
                            case 'MA':
                            case 'LR': // Liberia
                                colorExpression.push(unp, '#00DFDF');
                                break;

                            case 'HT':
                            case 'IT':
                            case 'IE':
                            case 'ET':
                                colorExpression.push(unp, '#55AA55');
                                break;

                            case 'GR':
                            case 'ES':
                            case 'TD': // Chad
                            case 'PA': // Panama
                            case 'TT': // Trinidad and Tobago
                                colorExpression.push(unp, '#EF8F00');
                                break;

                            case 'BN':
                                colorExpression.push(unp, '#0080ff');
                                break;

                            case 'YE':
                            case 'SR': // Suriname
                            case 'DM': // Dominica
                                opacityExpression.push(unp, 0.3);
                            case 'SD':
                                colorExpression.push(unp, '#3bb2d0');
                                break;

                            case 'DK':
                            case 'EE':
                            case 'DO':
                                colorExpression.push(unp, '#0000AA');
                                break;

                            case 'AF':
                            case 'MN':
                            case 'FI':
                            case 'NE':
                            case 'HU':
                            case 'PE':
                            case 'TN':
                            case 'MW':
                            case 'LA':
                            case 'SS':
                            case 'QA':
                            case 'GW': // Guinea-Bissau
                                colorExpression.push(unp, '#0000FF');
                                break;

                            case 'MZ':
                            case 'SE':
                                colorExpression.push(unp, '#238885');
                                break;

                            case 'FJ':
                            case 'PH':
                            case 'IL':
                            case 'US':
                                colorExpression.push(unp, '#007FFF');
                                break;

                            case 'AG': // Antigua and Barbuda
                            case 'BE':
                            case 'UA':
                            case 'HR':
                            case 'AU':
                            case 'AT':
                            case 'CL':
                            case 'TZ':
                            case 'GY': // Guyana
                            case 'NI': // Nicaragua
                                colorExpression.push(unp, '#FFDF00');
                                break;

                            default:
                                colorExpression.push(unp, '#f6a192');
                                break;
                        }
                    }
                }
                colorExpression.push('rgba(0, 0, 0, 0)'); // Invisible, to avoid blinking when 1 point visited in country is already level >1
                opacityExpression.push(0.2);
            }
        } else {
            // The highlight-color is hex or falsy
            return {
                'fill-color': map_settings['highlight-color'] ?? '#f6a192',
                'fill-opacity': (map_settings['highlight-color'] === '#FFFFFF') ? 0.4 : 0.2,
            };
        }

        // Doble check and return colorExpression && opacityExpression for 'choropleth' and 'political'
        if(colorExpression.length < 5) colorExpression = '#f6a192';
        if(opacityExpression.length < 5) opacityExpression = 0.2;

        //console.log(`colorExpression= ${JSON.stringify(colorExpression)}`);
        //console.log(`opacityExpression= ${JSON.stringify(opacityExpression)}`);
        return {
                'fill-color': colorExpression,
                'fill-opacity': opacityExpression,
        }
    }

    function getBorderColor(map_settings) {
        if(!map_settings['highlight-color']) return '#f6a192';

        return /^#[0-9A-Fa-f]{6}$/.test(map_settings['highlight-color']) ? map_settings['highlight-color'] : '#999999';
    }

    let previousSelectedRegId = $state(null);

    $effect(() => {
        if(previousSelectedRegId) {
            map.setFeatureState({
                    source: 'beenEW_regions',
                    sourceLayer: 'borders', // for mbtiles/pmtiles
                    id: previousSelectedRegId
                }, { selected: false });
        }

        if(selectedRegIntId) {
            map.setFeatureState({
                    source: 'beenEW_regions',
                    sourceLayer: 'borders', // for mbtiles/pmtiles
                    id: selectedRegIntId,
                }, { selected: true });
            previousSelectedRegId = selectedRegIntId;
        }
    });

    // onhover
    function onMouseMove(e) {
        if (e.features.length > 0) {
            const top = e.features.reduce((max, current) => ((current.id > max.id && current.source == 'beenEW_regions') ? current : max), e.features[0]);

            if(top.id !== selectedRegIntId) {
                selectedRegIntId = top.id;
            }
        }
    }

    // When the mouse leaves the state-fill layer, update the feature state of the
    // previously hovered feature
    function onMouseLeave() {
        if (selectedRegIntId) {
            selectedRegIntId = null;
        }
    }

    function onContextMenu(e) {
        if (e.features.length > 0 && e.features[0]?.id) {
            contextMenu.display ? contextMenu.display = false : map_edit_onclick(e, map, {token})
        } else if(contextMenu.display) {
            contextMenu.display = false;
        }
    }

    function transformStyle(previousStyle, nextStyle) {

        // If the id found in array1 objs' ids, insert array2 before the found
        const insertBeforeId = (array1, array2, myId) => {
            const index = array1.findIndex(obj => obj.id === myId);
            if (index !== -1) {
                array1.splice(index, 0, ...array2);
            } else {
                // If the id is not found, append array2 to the end of array1
                array1.push(...array2);
            }
            return array1;
        };

        const aboveWaterIDs = ['beenEW_regions', 'beenEW_regions-selected'];
        const beforeSymbolIDs = ['beenEW_visited_points_heatmap'];

        var aboveWaterCustomLayers = [];
        var beforeSymbolCustomLayers = [];
        var otherCustomLayers = [];

        //if(previousStyle?.layers) console.log('previousStyle='+JSON.stringify(previousStyle.layers.map(obj => `${obj.id} (${obj.type})`)));
        //if(nextStyle?.layers) console.log('nextStyle='+JSON.stringify(nextStyle.layers.map(obj => `${obj.id} (${obj.type})`)));

        for (let i = 0; i < previousStyle.layers.length; i++) {
            if(previousStyle.layers[i].id.startsWith('beenEW_')) {
                if(aboveWaterIDs.includes(previousStyle.layers[i].id)) {
                    aboveWaterCustomLayers.push(previousStyle.layers[i]);
                } else if(beforeSymbolIDs.includes(previousStyle.layers[i].id)) {
                    beforeSymbolCustomLayers.push(previousStyle.layers[i]);
                } else {
                    otherCustomLayers.push(previousStyle.layers[i]);
                }
            }
        }

        var layers = nextStyle.layers.concat(otherCustomLayers);
        layers = insertBeforeId(layers, aboveWaterCustomLayers, getBeforeId({ style: nextStyle, aboveWater: true }));
        layers = insertBeforeId(layers, beforeSymbolCustomLayers, getBeforeId({ style: nextStyle, beforeSymbol: true }));

        var sources = nextStyle.sources;
        for (const [key, value] of Object.entries(previousStyle.sources)) {
            if (key.startsWith('beenEW_')) {
                sources[key] = value;
            }
        }
        //console.log('new layers='+JSON.stringify(layers.map(obj => `${obj.id} (${obj.type})`)));

        return {
            ...nextStyle,
            sources: sources,
            layers: layers
        };
    }

    function getBeforeId({map, style, aboveWater, beforeSymbol} = {}) {
        style = map ? map.getStyle() : style;

        const layers = Array.isArray(style?.layers) ? style.layers : [];

        let beforeId = undefined;
        for (let i = 0; i < layers.length; i++) {
            if(aboveWater) {
                if (layers[i].id === 'water'
                    || layers[i].id.startsWith('Marine area') // workaround charted-territory
                    || layers[i].id === 'satellite' // workaround satellite-hybrid not having water layer
                ) {
                    beforeId = layers?.[i+1]?.id;  // [i+1]: above 'water' or 'Marine area'
                    break;
                }
            }
            if(beforeSymbol) {
                if (layers[i].type === 'symbol'
                    // workaround: for americana, fiord-color and terrain consider only place_ symbols (not borders, contour_label etc)
                    && !(['Fiord Color', 'MapTiler Terrain', 'Americana'].includes(style?.name) && !layers[i].id.startsWith('place_'))
                    && !layers[i].id.startsWith('Water line/Levee') // workaround charted-territory
                    && !layers[i].id.startsWith('Special area of interest line')
                ) {
                    beforeId = layers[i].id;  // [i]: before 'symbol'
                    break;
                }
            }
        }
        return beforeId;
    }


    // Helper function: Validate and normalize hex input
    function validateHex(hex) {
        // Ensure it starts with # and is either 4 or 7 characters long
        if (/^#([0-9A-F]{3}){1,2}$/i.test(hex)) {
            // Convert #RGB to #RRGGBB
            if (hex.length === 4) {
                return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
            }
            return hex.toUpperCase();
        }
        throw new Error(`Invalid color format: ${hex}. Expected #RRGGBB or #RGB.`);
    }

    // Helper function: Convert #RRGGBB to [R, G, B]
    // May throw #RRGGBB color validation error
    function hexToRgb(hex) {
        hex = validateHex(hex);
        const bigint = parseInt(hex.slice(1), 16);
        return [ (bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255 ];
    }

    function generateHeatmapColor(circleStrokeColor, circleColor) {

        // Helper function: Interpolate between two colors
        function interpolateColor(color1, color2, t) {
            return color1.map((c, i) => Math.round(c + (color2[i] - c) * t));
        }


        // Validate and convert hex colors to [R, G, B]
        let outerColor = hexToRgb("#000000");   // Default to black)
        let innerColor = hexToRgb("#FFFFFF");   // Default to white
        try {
            outerColor = hexToRgb(circleStrokeColor);
            innerColor = hexToRgb(circleColor);
        } catch (error) {
            console.error(error.message);
        }

        // Generate intermediate colors
        const colorSteps = [
            `rgba(${outerColor[0]}, ${outerColor[1]}, ${outerColor[2]}, 0)`, // Fully transparent outer (empty)
            `rgba(${outerColor[0]}, ${outerColor[1]}, ${outerColor[2]}, 0.9)`, // Amost opaque outer (least dense)
            `rgba(${interpolateColor(outerColor, innerColor, 0.50).join(", ")}, 0.7)`, // Intermediate step 1
            `rgba(${interpolateColor(outerColor, innerColor, 0.75).join(", ")}, 0.9)`,  // Intermediate step 2
            `rgba(${innerColor[0]}, ${innerColor[1]}, ${innerColor[2]}, 1)`            // Fully opaque inner
        ];

        // Build heatmap expression
        const heatmapColor = ["interpolate", ["linear"], ["heatmap-density"],
            0, colorSteps[0],
            0.1, colorSteps[1],
            0.2, colorSteps[2],
            0.5, colorSteps[3],
            1, colorSteps[4]
        ];

        return heatmapColor;
    }

    // May throw #RRGGBB color validation error
    function hexToRgba(hex, alpha) {
        const [r, g, b] = hexToRgb(hex);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }


    function map_apply_settings(user_data, map_settings_override = null) {

        if(!map) {
            // map must be defined
            return;
            //throw new Error('map_apply_settings: map is not defined');
        }
                
        if(typeof user_data != 'object' || !Object.keys(user_data).length) {
            // user_data is incomplete
            console.error('user_data is incomplete');
            return;
        }

        let map_settings = map_settings_add_defaults(user_data?.map_settings, map_settings_override);

        if(typeAllowsEdits && user_data?.userpage && userpage == user_data?.userpage) {
            if(!active_editable) {
                if(geolocate_control) {
                    map.addControl(geolocate_control, 'bottom-left');

                    map.on('click', (e) => {
                        contextMenu.display ? contextMenu.display = false : map_edit_onclick(e, map, {token})
                    });

                    map.on('contextmenu', (e) => {
                        contextMenu.display ? contextMenu.display = false : map_edit_onclick(e, map, {token, contextmenu: true})
                    });

                    active_editable = true;
                    map.getCanvas().style.cursor = 'crosshair';
                    
                } else {
                    Sentry.captureMessage("PROBLEM: geolocate_control is not set, skipping");
                }
            } 
        } else {
            if(active_editable) {
                try {
                    map.removeControl(geolocate_control);
                    mapDisplayMessage({map});
                    map.getCanvas().style.cursor = '';
                } catch(e) {
                    Sentry.captureMessage("Error while trying to remove from map ", {extra: {error: e}});
                }
                active_editable = undefined;
            } 
        } 

        /*****/
        //const new_user_bounds = find_user_bounds(settings, user_data);
        //let bbox = [[5,-65],[10,80]]; 

        if(map_settings?.zoom && map_settings?.center) {
            if(!active_map_settings?.zoom && !active_map_settings?.center) {  // Once per lifecycle
                    map.setZoom(map_settings.zoom);
                    map.setCenter(map_settings.center);
                    active_map_settings.zoom = map_settings.zoom;
                    active_map_settings.center = map_settings.center;
            }
        } else {
            // !!! it is bbox, not view&&map_bounds, because view&&map_bounds != bbox when view == 'been' !!!
            const new_bbox = find_user_bounds(map_settings, user_data);
            if(new_bbox) {
                if(active_map_settings?.bbox?.[0]?.[0] != new_bbox[0][0] ||
                    active_map_settings?.bbox?.[0]?.[1] != new_bbox[0][1] ||
                    active_map_settings?.bbox?.[1]?.[0] != new_bbox[1][0] ||
                    active_map_settings?.bbox?.[1]?.[1] != new_bbox[1][1]) {
                        ///console.log("bbox was = "+JSON.stringify(active_map_settings?.bbox)+" new="+JSON.stringify(new_bbox));
                        map.fitBounds(new_bbox, {
                                        duration: 500,
                                        essential: false
                                    });
                        active_map_settings.bbox = new_bbox;
                }
            } else {
                Sentry.captureMessage("map_apply_settings0: find_user_bounds returned falsy new_bbox", {
                            extra: {
                                    active_map_settings : JSON.stringify(active_map_settings),
                                    new_bbox: JSON.stringify(new_bbox),
                                    map_settings: JSON.stringify(map_settings),
                            }});
            }
        }
        /*****/
        

        if(active_map_settings?.style != map_settings.style) {
            map.setStyle(map_style_url(map_settings.style), {
                transformStyle: transformStyle
            });
            active_map_settings.style = map_settings.style; // svelte5
            map.once('idle', () => {
                //active_map_settings.map_style = map_settings.style; 
                map_apply_settings0(map, user_data, map_settings);
            });            
        } else {
            map_apply_settings0(map, user_data, map_settings);
        }
    }
    
    function map_apply_settings0(map, user_data, settings, iteration = 0) {

        if (!map.isStyleLoaded()) {
            if(iteration <= 20) {
                setTimeout(() => {map_apply_settings0(map, user_data, settings, iteration+1)}, 100); // was 200 svelte5
                return;
            } else {
                console.error('map_apply_settings0: Style is not loaded after iteration '+iteration);
                //return;
            }
        }
        //console.log("map_apply_settings0, new settings="+JSON.stringify(settings));



        /*if(!("highlight-countries" in settings)) settings["highlight-countries"] = "yes";
        if(!("show-locations" in settings)) settings["show-locations"] = "points";
        if(!("heatmap-color" in settings)) settings["heatmap-color"] = 1;*/

        if(active_userpage != userpage) {
            console.log('active_userpage change from '+active_userpage+' to '+userpage);
            if (map.getLayer('beenEW_regions')) {
                map.removeLayer('beenEW_regions');
            }
            if (map.getLayer('beenEW_region-borders')) {
                map.removeLayer('beenEW_region-borders');
            }
            if (map.getLayer('beenEW_visited_points')) {
                ////console.log("map.removeLayer('visited_points');");
                map.removeLayer('beenEW_visited_points');
            }
            if (map.getLayer('beenEW_visited_points_heatmap')) {
                ///console.log("map.removeLayer('visited_points_heatmap');");
                map.removeLayer('beenEW_visited_points_heatmap');
            }
            if(map.getSource('beenEW_visited_points')) {
                ///console.log("map.removeSource('visited_points')");
                map.removeSource('beenEW_visited_points');
            }
            active_userpage = undefined;
        }

        if(!userpage) {
            user_data = {};
        }

        if(jsonDeepEqual(active_map_settings, settings)) {
            console.log("map_apply_settings0: active_map_settings and settings equal, skipping");
            return;
        }

        /***** HIGHTLIGHT COUNTRIES LAYER *****/

        if(settings['highlight-countries'] == 'yes' || ['yes', 'un', 'unp', 'tcc', 'reg'].includes(settings['highlight-countries'])) {

            if(!map.getSource('beenEW_regions')) {
                map.addSource('beenEW_regions', {
                    type: 'vector',
                    url: PUBLIC_BORDERS_SRC,
                });
            }

            if(!map.getLayer('beenEW_regions')) {
                map.addLayer({
                    'id': 'beenEW_regions',
                    'type': 'fill',
                    'source': 'beenEW_regions',
                    'source-layer': 'borders', // for mbtiles/pmtiles
                    'layout': {},
                    'paint': makePaintExpression(user_data, settings),
                    maxzoom: +PUBLIC_REGIONS_MAX_ZOOM,
                    'filter': regFilterExpr,
                }, getBeforeId({map, aboveWater: true }));
            }

            if(settings?.['highlight-countries'] == 'reg') {
                if(!map.getLayer('beenEW_region-borders')) {
                    map.addLayer({
                        'id': 'beenEW_region-borders',
                        'type': 'line',
                        'source': 'beenEW_regions',
                        'source-layer': 'borders', // for mbtiles/pmtiles
                        'layout': {},
                        'paint': {
                            'line-color': getBorderColor(settings),
                            'line-width': 1,
                            'line-opacity': 0.2,
                        },
                        maxzoom: +PUBLIC_REGIONS_MAX_ZOOM,
                        'filter': borderFilterExpr,
                    });
                }
            }

        } else {   // (settings["highlight-countries"] === 'no'
            if (map.getLayer('beenEW_regions')) {
                map.removeLayer('beenEW_regions');
            }
            if (map.getLayer('beenEW_region-borders')) {
                map.removeLayer('beenEW_region-borders');
            }
        }

        if(['un','unp','tcc','reg','auto'].includes(settings?.['select-regions'])) {
            selectedRegType = (settings['select-regions'] != 'auto') ? settings['select-regions'] :
                (settings['highlight-countries'] != 'yes' ?  settings['highlight-countries'] : 'unp');

            if(!map.getLayer('beenEW_regions-selected')) {
                map.addLayer({
                    'id': 'beenEW_regions-selected',
                    'type': 'fill',
                    'source': 'beenEW_regions',
                    'source-layer': 'borders', //'regions', // mbtiles/pmtiles
                    'layout': {},
                    'filter': ['==', (selectedRegType == 'reg'? 'R' : selectedRegType == 'tcc' ? 'T' : 'UP'), 1],
                    'paint': {
                        'fill-color': '#787878', //getBorderColor(settings), //paintExpression['fill-color'], //'#627BC1',
                        'fill-opacity': [
                                            'step',
                                            ['zoom'],
                                            [
                                                'case',
                                                ['boolean', ['feature-state', 'selected'], false],
                                                0.075,
                                                0
                                            ],
                                            +PUBLIC_REGIONS_MAX_ZOOM, 0
                                        ],
                    },
                }, getBeforeId({map, aboveWater: true }));
            } else {
                map.setFilter('beenEW_regions-selected', ['==', (selectedRegType  == 'reg'? 'R' : selectedRegType == 'tcc' ? 'T' : 'UP'), 1]);
            }

            if(!map.getLayer('beenEW_regions-selected-borders')) {
                //console.log('map.addLayer(regions-hover-borders)');
                map.addLayer({
                    'id': 'beenEW_regions-selected-borders',
                    'type': 'line',
                    'source': 'beenEW_regions',
                    'source-layer': 'borders', //'regions', // mbtiles/pmtiles
                    'layout': {},
                    'paint': {
                        'line-color': '#787878', // getBorderColor(settings),
                        'line-width': 1,
                        'line-opacity': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            1,
                            0
                        ],
                    },
                    //'filter': ['in', 'reg'],
                    maxzoom: +PUBLIC_REGIONS_MAX_ZOOM,
                });
            }

            if(settings?.['select-regions-on'] != 'click') { // capacitor?
                //  settings?.['select-regions'] == 'hover', which is default
                map.on('mousemove', 'beenEW_regions-selected', onMouseMove);
                // When the mouse leaves the state-fill layer, update the feature state of the
                // previously hovered feature.
                map.on('mouseleave', 'beenEW_regions-selected', onMouseLeave);
            }
        } else {
            map.off('mousemove', 'beenEW_regions-selected', onMouseMove);
            map.off('mouseleave', 'beenEW_regions-selected', onMouseLeave);
            if (map.getLayer('beenEW_regions-selected')) {
                map.removeLayer('beenEW_regions-selected');
            }
            if (map.getLayer('beenEW_regions-selected-borders')) {
                map.removeLayer('beenEW_regions-selected-borders');
            }
            selectedRegType = undefined;
        }



        /* VISITED LOCATIONS LAYER */
        //if($user_data && $user_data?.type === "FeatureCollection") {
        //if($user_data?.profile?.id) {
            //console.log(JSON.stringify($user_data));
            if(settings["show-locations"] !== 'off' || active_editable /* overrides 'off' */) {
                if(!map.getSource('beenEW_visited_points') && userpage) {
                    //console.log("adding source visited_points: /query-visits/"+user_data.profile.userpage);
                    if(user_data?.userpage && userpage == user_data?.userpage && user_data?.type == "FeatureCollection") {
                        console.log(`Using source: user_data: userpage=${userpage}, user_data.userpage=${user_data?.userpage}, user_data.type=${user_data?.type}`);
                        map.addSource('beenEW_visited_points', {
                            type: 'geojson',
                            //data: $user_data, //query_visits_api
                            //data: server_name("/api?query_visits="+user_data?.profile?.id),
                            data: user_data,
                        });
                        active_userpage = userpage;
                    } else {
                        let src = server_name("/query-visits/"+userpage+(secret ? `?secret=${secret}` : ''));
                        console.log(`Using source: ${src}: userpage=${userpage}, user_data.userpage=${user_data?.userpage}, user_data.type=${user_data?.type}`);
                        map.addSource('beenEW_visited_points', {
                            type: 'geojson',
                            //data: $user_data, //query_visits_api
                            //data: server_name("/api?query_visits="+user_data?.profile?.id),
                            data: src,
                        });
                        active_userpage = userpage;
                    }
                    ////console.log("check: map.getSource('visited_points') = "+map.getSource('visited_points'));
                }            
            }
        //}

        if(settings["show-locations"] === 'off' || settings["show-locations"] === 'points') {
            if (map.getLayer('beenEW_visited_points_heatmap')) {
                ///console.log("map.removeLayer('visited_points_heatmap');");
                map.removeLayer('beenEW_visited_points_heatmap');
            }            
        }    
        if(settings["show-locations"] === 'off' || settings["show-locations"] === 'heatmap') {
            if (map.getLayer('beenEW_visited_points')) {
                ////console.log("map.removeLayer('visited_points');");
                map.removeLayer('beenEW_visited_points');
            }            
        }
        if(settings["show-locations"] === 'points' || settings["show-locations"] === 'heatmap-points' || active_editable /* overrides 'off' */ ) {

            //document.getElementById('circle-color').classList.remove("disabled");
            //document.getElementById('circle-stroke-color').classList.remove("disabled");


            if (map.getLayer('beenEW_visited_points')) {
                ////console.log("map.removeLayer('visited_points');");
                map.removeLayer('beenEW_visited_points');
            } 

            /*console.log("map.addLayer: "+JSON.stringify({
                'id': 'visited_points',
                'type': 'circle',
                'source': 'visited_points',
                'minzoom': (settings["show-locations"] == 'points'? 0 : 7), ///!!!
                'paint': {
                    'circle-radius':  {
                        'stops': [
                                [1, 3],
                                [4, 4],
                                [10, 6],
                                [14, 10],
                                [16, 14],
                                [18, 18]
                            ]
                    },
                    'circle-color': settings['circle-color'] ?? '#e55e5e',
                    'circle-stroke-width': 1.5,
                    'circle-stroke-color': settings['circle-stroke-color'] ?? 'white',
                }
            }));      */   

            //let circleColor = (settings["show-locations"] === 'off' && settings?.editable) ? 'rgba(255,255,255,0)' : (settings['circle-color'] ?? '#e55e5e');
            let circleColor = settings['circle-color'] ?? '#e55e5e';
            let circleStrokeWidth = 1.5;
            let circleStrokeColor = settings['circle-stroke-color'] ?? 'white';
            /*
            if(settings["show-locations"] === 'off' && settings?.editable) { 
                circleColor = 'rgba(255,255,255,0.5)';
                circleStrokeWidth = 0.5;
                circleStrokeColor = 'rgba(0,0,0,0.5)';
            }*/


            if(map.getSource('beenEW_visited_points')) {
                map.addLayer({
                    'id': 'beenEW_visited_points',
                    'type': 'circle',
                    'source': 'beenEW_visited_points',
                    'minzoom': (settings["show-locations"] === 'points' || (settings["show-locations"] === 'off' && active_editable))
                                ? 0 : 7, ///!!!
                    'paint': {
                        'circle-radius':  {
                            'stops': [
                                    [1, 3],
                                    [4, 4],
                                    [10, 6],
                                    [14, 10],
                                    [16, 14],
                                    [18, 18]
                                ]
                        },
                        // Transit point: stroke is visible, circle is almost transparent
                        // Hidden point: circle and stroke are both transparent
                        'circle-color': [
                            'case',
                            ['==', ['get', 'T'], 1],
                            'rgba(255, 255, 255, 0.33)',
                            ['==', ['get', 'H'], 1],
                            hexToRgba(circleColor, 0.5),
                            circleColor,
                        ],
                        'circle-stroke-color': [
                            'case',
                            ['==', ['get', 'H'], 1],
                            hexToRgba(circleStrokeColor, 0.5),
                            circleStrokeColor,
                        ],
                        'circle-stroke-width': circleStrokeWidth,
                    },
                    layout: {
                        "circle-sort-key": ["to-number", ["get", "sk"], 0],
                    },
                });
            }

            active_map_settings["circle-color"] = circleColor;
            active_map_settings["circle-stroke-color"] = circleStrokeColor;
         
            ///console.log("check: map.getLayer('visited_points') = "+map.getLayer('visited_points'));
            //console.log("map.addLayer(visited_points)");
        } /*else {
            document.getElementById('circle-color').classList.add("disabled");
            document.getElementById('circle-stroke-color').classList.add("disabled");
        }*/


        if(settings["show-locations"] == 'heatmap' || settings["show-locations"] == 'heatmap-points') {
            //document.getElementById('heatmap-color').classList.remove("disabled");
            
            if (map.getLayer('beenEW_visited_points_heatmap')) {
                ///console.log("map.removeLayer('visited_points_heatmap');");
                map.removeLayer('beenEW_visited_points_heatmap');
            }            

            let heatmap_color = false;
            switch(settings["heatmap-color"]) {
                case "0":
                    heatmap_color = generateHeatmapColor(active_map_settings["circle-stroke-color"], settings['circle-color']);
                    break;
                default:
                case "1":
                    heatmap_color = ["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"#ffffb2",0.3,"#feb24c",0.5,"#fd8d3c",0.7,"#fc4e2a",1,"#e55e5e"];
                    break;
                case "2":
                    heatmap_color = ['interpolate',['linear'],['heatmap-density'],0,'rgba(33,102,172,0)',0.2,'rgb(103,169,207)',0.4,'rgba(246, 161, 146, 0.5)',0.6,'rgb(253,219,199)',0.8,'rgb(239,138,98)',1, "#e55e5e"];
                    break;
                case "3":
                    heatmap_color = ["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"rgba(0, 0, 255, 0.7)",0.3,"#00ff00",0.5,"#FFFF00",1,"#ff0000"];
                    break;
            }   

            let layer_def = {
                'id': 'beenEW_visited_points_heatmap',
                'type': 'heatmap',
                'source': 'beenEW_visited_points',
                'maxzoom': 9,
                'paint': {
                /*// Increase the heatmap weight based on frequency and property magnitude
                'heatmap-weight': [
                    'interpolate',
                    ['linear'],
                    ['get', 'mag'],
                    0,
                    0,
                    6,
                    1
                ],*/
                // Increase the heatmap color weight weight by zoom level
                // heatmap-intensity is a multiplier on top of heatmap-weight
                'heatmap-intensity': [
                'interpolate',
                    ['linear'],
                    ['zoom'],
                    0,
                    1,
                    9,
                    3
                ],
                // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                // Begin color ramp at 0-stop with a 0-transparancy color
                // to create a blur-like effect.
                "heatmap-color": heatmap_color,
                // Adjust the heatmap radius by zoom level
                'heatmap-radius': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    0,
                    2, //2,
                    9,
                    25 //20
                ],
                // Transition from heatmap to circle layer by zoom level
                'heatmap-opacity': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    7,
                    1,
                    9,
                    0
                ]
                }
            };

            //console.log("map.addLayer('visited_points_heatmap')")
            map.addLayer(layer_def, getBeforeId({map, beforeSymbol: true }));
            
            //map.addLayer(layer_def);        
        } else {
            //document.getElementById('heatmap-color').classList.add("disabled");
        }

        active_map_settings["view"] = settings?.["view"];
        active_map_settings["show-locations"] = settings?.["show-locations"];
        active_map_settings["highlight-countries"] = settings?.["highlight-countries"];
        active_map_settings["region-borders"] = settings?.["region-borders"];
        active_map_settings["select-regions"] = settings?.["select-regions"];
        active_map_settings["select-regions-on"] = settings?.["select-regions-on"];
        active_map_settings["highlight-color"] = settings?.["highlight-color"];
        active_map_settings["heatmap-color"] = settings?.["heatmap-color"];


        ////console.log("map_apply_settings0 finished...");
    }


    function map_on_movened() {
        /*
            map.getBounds()

            let sw = new LngLat(-73.9876, 40.7661);  // The southwest corner of the bounding box
            let ne = new LngLat(-73.9397, 40.8002);  // The northeast corner of the bounding box.
            let llb = new LngLatBounds(sw, ne);

            viewbox:

            [swLng, swLat, neLng, neLat] == [west, south, east, north]

        */
        const mapbounds = map.getBounds().toArray();

        if(map_covered) {
            mapbounds[0][1] = mapbounds[1][1] - (mapbounds[1][1] - mapbounds[0][1]) * map_covered;
        }
        const viewbox = [mapbounds[0][0],mapbounds[0][1],mapbounds[1][0],mapbounds[1][1]].join();

        if(on_moveend_search && on_moveend_search.viewbox == viewbox) return;

        if (typeof on_moveend_func === 'function') {
            on_moveend_func();
        }

        if(!on_moveend_search) return;

        if(disable_map_on_movened) {
            if(is_natural(disable_map_on_movened)) {
                console.log('disable_map_on_movened='+disable_map_on_movened);
                disable_map_on_movened = (disable_map_on_movened <= 1) ? false : disable_map_on_movened - 1;
            }
            return;
        }

        const formData = new FormData();
        formData.append('page', window.location.pathname);
        formData.append('viewbox', viewbox);
        fetch(server_name('/_api/nominatim/moveend'), {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
            ...(token && { headers: { Authorization: `Bearer ${token}` } })
        })
        .then(handleFetch, handleFetchReject)
        .then((data) => { 
            if(data.error) {
                if(on_moveend_search) {
                    on_moveend_search = { error: data?.error };
                }
                //map_display_overlay(map, data.error);
            //} else if(data.length > 0) {
            } else if(Array.isArray(data)) {
                if(on_moveend_search) {
                    on_moveend_search = {
                        data,
                        movened: true,
                        viewbox,
                    };
                }

                mapDisplayMessage({map});
                if(document.getElementById("t_cities")) { /* /mymap/add */
                    //button_enable("b_search");
                    city_search_success_function(map, data, {token, capacitor});
                } else {
                    //map_display_overlay(map, data[0].name /*+ visited*/, 'toggle-visit', data[0].osm_uid, data[0].already_visited);
                }
            } else  {
                //map_display_overlay(map, 'Not found');
            }
        });
    }

    function is_aerodrome(feature) {
        return (feature?.properties?.iata || feature?.properties?.icao);
    }

    function map_edit_onclick(e, map, {token, contextmenu} = {}) {

        const clickable_class = ["city", "town", "village", "hamlet", "island", "castle", "national_park", "parque_nacional", "aerodrome", "_been"];
        const clickable_names = ["Luxembourg", "Sakhalin", "San Marino", "Monaco", "Gibraltar", "Vatican", "Vatican City", "Singapore", "Hong Kong", "Macao", "Macau", "Andorra", "Gorée", "Dunedin", "Jungfraujoch", "Gornergrat"]; // dirty

        const features = map.queryRenderedFeatures(e?.point);

        if(!Array.isArray(features) || features.length < 1) {
            return;
        }

        let ft_name = undefined;
        let ft_class = undefined;

        /* Obsolte:
            - We now have Vatican lable on every source
            - If not, we can add check for click on beenEW_regions && reg=VA

        // is Vatcan?
        if(12.448 <= e.lngLat.lng &&  e.lngLat.lng <= 12.458 && 41.90 <= e.lngLat.lat && e.lngLat.lat <= 41.91) {
            ft_name = 'Vatican City';
            ft_class = 'city';
        } else
        */

        ft_name = features[0].properties?.['name:en'] ?? features[0].properties?.name;
        if(features[0].properties?.kind || features[0].properties?.kind_detail) {    // pmtiles
            ft_class = features[0].properties?.kind || features[0].properties?.kind_detail;
            if(ft_class === 'water') ft_class = 'water body';
            clickable_class.push('locality');
        } else {
            ft_class = features[0].properties?.class;
        }

        if(active_map_settings?.style === 'charted-territory' && ft_class !== '_been') {
            //console.log('charted-territory/properties='+JSON.stringify(features[0].properties));
            //console.log('charted-territory/layer='+JSON.stringify(features[0]?.layer));
            ft_name = (features[0].properties?.['_name_en']
                ?? features[0].properties?.['_name_global'])
                ?? features[0].properties?.['_name']
                ?? features[0].properties?.['_name_local']
                ?? features[0].properties?.name;

            if(features[0].layer.id.startsWith('City') || features[0].layer.id.startsWith('Airport')) {
                ft_class = 'city';
            } else if(features[0].layer.id.startsWith('Admin0')) {
                if(features[0].layer.id.includes('forest or park')) {
                    ft_class = 'national_park';
                } else {
                    ft_class = 'country';
                }
            } else if(features[0].layer.id.startsWith('Admin1')) {
                ft_class = 'state';
            } else if(features[0].layer.id.startsWith('Road')) {
                ft_class = 'road';
            } else if(features[0].layer.id == 'Spot elevation' || features[0].layer.id.startsWith('Graticule/label')) {
                ft_name = null;
                ft_class = false;
            } else {
                ft_class = false;
            }
        } else {
            if(["primary", "secondary", "tertiary", "minor", "trunk", "service"].includes(ft_class)) {
                ft_class = "road";
            }
            if(["major_road", "minor_road"].includes(ft_class)) { // pmtiles
                ft_class = "road";
            }
        }

        if(features[0].source == 'beenEW_regions' && map.getZoom() <= 7) {
            // Find "top" (smalled region at the point)
            const top = features.reduce((max, current) => ((current.source == 'beenEW_regions' && current.id > max.id) ? current : max), features[0]);

            ft_class = (top.properties?.reg && top.properties?.reg.length == 2) ? 'country' : 'region';
            const region = get_region_by_id(top.properties?.reg) || [];
            ft_name = region[3] || region[1] || top.properties?.reg;
            if(['New York', 'Washington', 'Bremen'].includes(ft_name)) {
                ft_name = 'the state of '+ft_name;
            }
            if(['Berlin', 'Hamburg', 'Moscow', 'Minsk', 'Istanbul', 'Lisbon'].includes(ft_name)) {
                ft_class = 'city';
            }
            if(/:/.test(top.properties?.reg) && !/(region|island)/i.test(ft_name)) {
                ft_name = `the ${selectedRegType == 'tcc' ? "TCC" : ""} region of "${ft_name}"`;
            }

            selectedRegIntId = top.id;
        } else if(active_map_settings?.['select-regions-on'] == 'click') {
            selectedRegIntId = null;
        }

        const search_field = document.getElementById("search"); /* This is /mymap/add */

        if(clickable_class.includes(ft_class) || clickable_names.includes(ft_name) || is_aerodrome(features?.[0])) {
            if(ft_name == "Victoria Falls" && ft_class == "town") { 
                ft_name = "Victoria Falls town"; 
            }
            if(ft_name == "Gorée" && ft_class == "suburb") { 
                ft_name = "Island of Gorée"; 
            } // very dirty yeah

            //console.log("feature name2: "+ft_name);

            hapticsImpactMedium().catch((err) => console.error('hapticsImpactMedium err: '+err));

            disable_map_on_movened = capacitor ? 2 : true;
            mapDisplayMessage({map, msg: ft_name, type: 'loading'});
            if(search_field) { /* This is /mymap/add */
                search_field.value = ft_name;
                // Disable results on moveend
                //const el = document.getElementById('disable_map_on_movened');
                //if(el) el.value = 'yes';
                //??//disable_map_on_movened = true;
            }

            let mapbounds = map.getBounds().toArray();
            let viewbox = [mapbounds[0][0],mapbounds[0][1],mapbounds[1][0],mapbounds[1][1]].join();

            const formData = new FormData();
            //formData.append('user_id', document.getElementById("user_id").value);
            //formData.append('api_key', document.getElementById("api_key").value);
            formData.append('search', ft_name);
            formData.append('page', window.location.pathname);
            //formData.append('page', $page.url.pathname);
            formData.append('viewbox', viewbox);
            //console.log(JSON.stringify(e.lngLat));
            formData.append('coordinates', [e.lngLat.lng, e.lngLat.lat].join());

            // Obsolete: I now do this without going to the server
            /*
            if(ft_class == '_been') {
                if(is_osm_uid(features?.[0]?.['properties']?.['id'])) {
                    formData.append('osm_uid', features[0]['properties']['id']);
                } else {
                    Sentry.captureMessage("ft_class == '_been', but bad osm_uid ", {extra: {properties: features?.[0]?.['properties']}});
                }
            }*/
            
            (() =>
            //fetch('/api', {
                ft_class == '_been'
                    ? Promise.resolve([{
                        osm_uid: features[0]['properties']['id'],
                        name: ft_name,
                        label: ft_name,
                        coordinates: [e.lngLat.lng, e.lngLat.lat]
                    }])
                    : fetch(server_name('/_api/nominatim/search'), {
                        method: 'POST',
                        body: formData,
                        credentials: 'same-origin',
                        ...(token && { headers: { Authorization: `Bearer ${token}` } })
                    })
                    //.then(fetchHandler)
                    .then(handleFetch, handleFetchReject)
            )()
            .then((data) => { // Parsed JSON passed as `data`
                if(on_moveend_search) {
                    if(data.error) {
                        on_moveend_search = { error: data?.error };
                    } else {
                        on_moveend_search = { data };
                    }
                }
                
                if(data.error) {
                    mapDisplayMessage({map, error: data.error});
                } else if(data.length > 0) {
                    //let visited = data[0].already_visited ? '[Visited!]' : '[Add!]';
                    /*map_overlay.innerHTML = '<div class="level is-mobile">' + data[0].name + visited + '</div>';
                    map_overlay.style.visibility = "visible";*/
                    if(document.getElementById("t_cities")) { /* /mymap/add */
                        //map_display_overlay(map, "");
                        button_enable("b_search");
                        city_search_success_function(map, data, {focusFirst: true, token, capacitor});
                    } else {
                        //mapDisplayMessage({map, msg: data[0].name /*+ visited*/, type: 'toggle-visit', osm_uid: data[0].osm_uid /*, data[0].already_visited*/});
                        mapDisplayMessage({map, msg: data[0].name, type: 'toggle-visit', token,
                                                osm_uid: data[0].osm_uid,
                                                visitors: data[0].visitors});
                    }

                    if(contextmenu) {
                        contextMenu.label = data[0].name;
                        contextMenu.osm_uid = data[0].osm_uid;
                        contextMenu.display = true;
                        contextMenu.left = e.originalEvent.pageX;
                        contextMenu.top = e.originalEvent.pageY;
                        contextMenu.visitors = data[0].visitors;
                    }
                } else  {
                    mapDisplayMessage({map, msg: 'Not found'});
                }
            });/*!!!!
            .catch((error) => {
                //console.log(JSON.stringify(error));
                if(!error || !error.length) {
                    //map_overlay.innerHTML = placeholder('<i class="has-text-info">Not found</i>');
                    map_display_overlay(map, "Not found");
                } else {
                    //map_overlay.innerHTML = placeholder('<i class="has-text-info">' + JSON.stringify(error) + '</i>');
                    map_display_overlay(map, JSON.stringify(error));
                }
            });*/

        } else {
            if(ft_name) {
                if(search_field) { /* This is /mymap/add */
                    search_field.value = "";
                }

                /*map_overlay.style.visibility = "visible";*/
                if(ft_class == 'country' || ft_class == 'region' || ft_class == 'state') {
                    /*map_overlay.innerHTML = placeholder('<i class="has-text-info">To add a country, zoom&nbsp;in and add cities</i>');*/
                    //mapDisplayMessage({map, msg: `To add a ${ft_class}, zoom&nbsp;in and add cities`});
                    mapDisplayMessage({map, msg: `To add ${ft_name}, zoom&nbsp;in and add cities`});
                    //disable_map_on_movened = false;
                } else if(ft_class) {
                    ft_class = ft_class.replace(/_/g, ' ');
                        /*map_overlay.innerHTML = placeholder('<i class="has-text-info">'+ ft_name + " is not a city (it's " + a_or_an(ft_class) + " " + ft_class + ')</i>');*/
                    mapDisplayMessage({map, msg: `${ft_name} is not a city (it's ${a_or_an(ft_class)} ${ft_class})`});
                } else {
                        /*map_overlay.innerHTML = placeholder('<i class="has-text-info">'+ ft_name + ' is not a city</i>');*/
                        mapDisplayMessage({map, msg: `${ft_name} is not a city`});
                }
                return;
            } else if(!user_data?.stats?.places_visited) {
                //if(document.getElementById('places_visited')?.innerHTML <= 0) {
                /*map_overlay.style.visibility = "visible";
                map_overlay.innerHTML = placeholder('<i class="has-text-info">Click city labels to add cities</i>');*/
                mapDisplayMessage({map, msg: "Click city labels to add cities"});
            } else {
                /*map_overlay.style.visibility = "hidden";*/
                mapDisplayMessage({map});
            }
            //console.log(features[0]['properties']['name'] + " is " + features[0]['properties']['class']);
            //console.log(features[0]);
        } 
    }

    // Hide context menu when clicking anywhere else
    function onclickOutsideContextMenu(event) {
        contextMenu.display = false;
    };

    let visitState = $derived.by(() => { return get_osm_uid_state(user_data, contextMenu.osm_uid) });

    function onclickSmallOverlay(e) {
        if (!e.currentTarget) return;

        if(e.currentTarget.querySelector('.has-text-info') !== null) {
            e.preventDefault();
            mapDisplayMessage({map});
        }
    }


    async function onclickContextMenu(e, action) {
        e.preventDefault();

        switch(action) {
            case 'been':
                return await toggle_visit (map, visitState.visited ? 'remove' : 'add', { token, osm_uid: contextMenu.osm_uid, flyToOnBeen: contextMenu.flyToOnBeen});

            case 'hide':
                return await toggle_visit (map, visitState.visited ? 'update' : 'add', { token, osm_uid: contextMenu.osm_uid, flyToOnBeen: contextMenu.flyToOnBeen, hide: (visitState.hidden ? "0" : "1")});

            case 'transit':
                return await toggle_visit (map, visitState.visited ? 'update' : 'add', { token, osm_uid: contextMenu.osm_uid, flyToOnBeen: contextMenu.flyToOnBeen, transit: (visitState.transit ? "0" : "1")});

            default:
                console.log('error in onclickContextMenu()');
                Sentry.captureMessage('error in onclickContextMenu()');
        }
    }

</script>

<script module>
    let contextMenuEl = $state();
    let contextMenu = $state({
        display: false,
        left: 5,
        top: 5,
        osm_uid: undefined,
        label: undefined,
        flyToOnBeen: false,
    });
    let module_map = $state();
    let module_capacitor = $state();


    export function updateVisitedPointsSource(featureCollection) {
        if(module_map) {
            const visitedPointsSource = module_map.getSource('beenEW_visited_points');

            if (visitedPointsSource) {
                visitedPointsSource.setData(featureCollection); // activeUserData.data
            } else {
                Sentry.captureMessage("toggle_visit: no beenEW_visited_points");
            }
        } else {
            Sentry.captureMessage("toggle_visit: module_map is falsy");
        }
    }


    export function showContextMenu({el, x, y, osm_uid, label, flyToOnBeen, visitors} = {}) {
        contextMenu.osm_uid = osm_uid;
        contextMenu.label = label;
        contextMenu.flyToOnBeen = flyToOnBeen;
        contextMenu.visitors = visitors;

        computePosition(
            el ? el : createVirtualElement(x, y),
            contextMenuEl, {
                placement: 'bottom-start',
                middleware: [offset(5), flip(), shift({padding: 5})],
        }).then(({ x, y }) => {
            contextMenu.display = true;
            contextMenu.left = x;
            contextMenu.top = y;
        });
    }

    export function mapDisplayMessage({map, msg, error, type, osm_uid, token, visitors} = {}) {
        const mymap_add_error = document.getElementById("mymap_add_error");     // /mymap/add
        const map_overlay = document.getElementById("small-overlay");           // /user/username

        if(error) {
            msg = error;
            type = 'danger';
        }

        if(mymap_add_error) { // /mymap/add
            document.getElementById("t_cities").innerHTML = "";
            mymap_add_error.innerHTML = "";
            if(type === 'danger') {
                mymap_add_error.classList.remove('has-text-info');
                mymap_add_error.classList.add('has-text-danger');
            } else {
                mymap_add_error.classList.remove('has-text-danger');
                mymap_add_error.classList.add('has-text-info');
            }

            switch(type) {
                case 'loading':
                    button_disable("b_search");
                    break;
                default:
                    button_enable("b_search");
                    mymap_add_error.innerHTML = msg ?? "";
                    break;
            }
        } else if(map_overlay) { // /user/username

            if(!module_capacitor) {
                updateContextMenuHandler(map_overlay, function (e) {
                        e.preventDefault(); // Prevent browser context menu
                        e.stopPropagation();
                    });
            }


            if(typeof msg === 'string') {
                //if(['ios', 'android', 'web'].includes(capacitor?.platform)) {
                if(module_capacitor) {
                    msg = msg.replace(/Click/g, 'Tap');
                    msg = msg.replace(/click/g, 'tap');
                } else {
                    msg.replace(/Tap/g, 'Click');
                    msg.replace(/tap/g, 'click');
                }

                // mx-1 mb-1
                const placeholder = (x) => "<div class='level is-mobile'>" + x +
                "<button style='visibility: hidden;' class='m-1 button is-light is-small'>B</button></div></div>";

                switch(type) {
                    case 'toggle-visit':
                        if(osm_uid && osm_uid != '') {
                            map_overlay.innerHTML = ''; // '<div class="level is-mobile">' + msg + '</div>';
                            var level = document.createElement("div");

                            if(module_capacitor) {
                                map_overlay.appendChild(level);
                                // <BeenControl {map} {token} {place} {capacitor}></BeenControl>
                                mount(BeenControl, {
                                    target: level,
                                    props: {
                                        map,
                                        token,
                                        place: {
                                            osm_uid,
                                            label: msg,
                                        },
                                        autofocus: true,
                                        capacitor: module_capacitor,
                                        take_max_width: true,
                                    }
                                });

                            } else {
                                level.className = 'level is-mobile';
                                map_overlay.appendChild(level);
                                var span = document.createElement("span");
                                span.innerHTML = msg;
                                level.appendChild(span);

                                mount(BeenButton, {
                                    target: level,
                                    props: {
                                        map,
                                        token,
                                        osm_uid,
                                        label: msg,
                                        autofocus: true,
                                        capacitor: module_capacitor,
                                        visitors,
                                    }
                                });
                            }

                            if(!module_capacitor) {
                                updateContextMenuHandler(map_overlay, function (e) {
                                        e.preventDefault(); // Prevent browser context menu
                                        e.stopPropagation();
                                        showContextMenu({el: level.lastElementChild, osm_uid, label: msg, visitors});
                                    });
                            }

                        } else {
                            Sentry.captureMessage("mapDisplayMessage tried to create BeenButton with an empty osm_uid", { extra: { osm_uid }});
                            map_overlay.innerHTML = placeholder('<i class=has-text-info>Internal error: no osm_uid</i>');
                        }
                        break;
                    case 'loading':
                        map_overlay.innerHTML = placeholder('<div class=animated-ellipsis>' + msg + '</div>');
                        break;
                    case 'danger':
                        map_overlay.innerHTML = placeholder('<i class=has-text-danger>'+msg+'</i>');
                        break;
                    case 'info':
                    default:
                        map_overlay.innerHTML = placeholder('<i class=has-text-info>'+msg+'</i>');
                        break;
                }
                map_overlay.style.visibility = "visible";
            } else {
                map_overlay.style.visibility = "hidden";
            }
        } else {
            alert(msg);
        }
    }


    function updateContextMenuHandler(el, handler) {
        if(!el) return;

        if (el._onContextMenu) {
            el.removeEventListener('contextmenu', el._onContextMenu);
            delete el._onContextMenu;
        }

        el._onContextMenu = handler;

        el.addEventListener('contextmenu', el._onContextMenu);
    }

    async function get_place_visitors(osm_uid, visitors) {
        if(visitors === undefined && is_osm_uid(osm_uid)) {
            const formData = new FormData();
            formData.append('osm_uid', osm_uid);

            const response = await fetch(server_name('/_api/nominatim/get-visitors'), {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
                //...(params.token && { headers: { Authorization: `Bearer ${params.token}` } })
            });

            const json = await handle_fetch(response, {
                clean: true         // allow numbers instead of strictly {}
            });

            if (json?.error) {
                console.error("get_place_visitors: "+json.error);
            } else {
                visitors = json;
            }
        }
        return Promise.resolve(visitors ? Intl.NumberFormat().format(visitors) : visitors === 0 ? "none" : "N/A")
    }


</script>

{#if !capacitor}
<!-- svelte-ignore a11y_interactive_supports_focus -->
<div bind:this={contextMenuEl} class="context-menu" role="menu"
    oncontextmenu={(e) => e.preventDefault() /* Prevent browser context menu */ }
    style={`left: ${contextMenu.left}px; top: ${contextMenu.top}px; display:${contextMenu.display ? "block" : "none"};`}>
    <div class="dropdown is-active">
        <div class="dropdown-menu" id="dropdown-menu" role="menu" aria-labelledby="dropdown-menu-label">
            <div class="dropdown-content" >
                <!-- svelte-ignore a11y_no_static_element_interactions -->
                <!-- svelte-ignore a11y_click_events_have_key_events -->
                <a id="dropdown-menu-label" class="dropdown-item is-disabled" tabindex="-1" onclick={(e)=>{e.preventDefault();e.stopPropagation();}}> {contextMenu.label}
                    {#if visitState.visited}
                        <svg class='svg-icon checkmark' use:tooltip data-tooltip="Been to"><use xlink:href='/i/fa.svg#circle-check'></use></svg>
                    {/if}
                    {#if visitState.hidden}
                        <svg class='svg-icon checkmark' use:tooltip data-tooltip="Hidden from other users"><use xlink:href='/i/fa.svg#eye-slash'></use></svg>
                    {/if}
                    {#if visitState.transit}
                        <svg class='svg-icon checkmark' use:tooltip data-tooltip="Transit"><use xlink:href='/i/fa.svg#plane'></use></svg>
                    {/if}
                    <p class="is-size-7 is-italic has-text-grey pt-1 pb-0">
                        Visited by
                        <svelte:boundary>
                        { await get_place_visitors(contextMenu.osm_uid, contextMenu.visitors) }
                        {#snippet pending()}
                            <span class="animated-ellipsis"></span>
                        {/snippet}
                        </svelte:boundary>
                    </p>
                </a>
                <hr class="dropdown-divider" />
                <!-- svelte-ignore a11y_missing_attribute -->
                <a class="dropdown-item flex" role="menuitem" tabindex="0"
                    onclick={async (e) => await onclickContextMenu(e, 'been')}
                    onkeydown={keydownWrapper(async (e) => await onclickContextMenu(e, 'been'))}
                    oncontextmenu={async (e) => await onclickContextMenu(e, 'been')}>
                    Been
                    {#if visitState.visited}
                        <svg class='svg-icon'><use xlink:href='/i/fa.svg#check'></use></svg>
                    {:else}
                        &nbsp;
                    {/if}
                </a>
                <!-- svelte-ignore a11y_missing_attribute -->
                <a class="dropdown-item flex" role="menuitem" tabindex="0"
                    onclick={async (e) => await onclickContextMenu(e, 'hide')}
                    onkeydown={keydownWrapper(async (e) => await onclickContextMenu(e, 'hide'))}
                    oncontextmenu={async (e) => await onclickContextMenu(e, 'hide')}>
                    Been (Hidden visit)
                    {#if visitState.visited && visitState.hidden}
                        <svg class='svg-icon'><use xlink:href='/i/fa.svg#check'></use></svg>
                    {:else}
                        &nbsp;
                    {/if}
                </a>
                <!-- svelte-ignore a11y_missing_attribute -->
                <a class="dropdown-item flex" role="menuitem" tabindex="0"
                    onclick={async (e) => await onclickContextMenu(e, 'transit')}
                    onkeydown={keydownWrapper(async (e) => await onclickContextMenu(e, 'transit'))}
                    oncontextmenu={async (e) => await onclickContextMenu(e, 'transit')}>
                    Been (Transit)
                    {#if visitState.visited && visitState.transit}
                        <svg class='svg-icon'><use xlink:href='/i/fa.svg#check'></use></svg>
                    {:else}
                        &nbsp;
                    {/if}
                </a>
            </div>
        </div>
    </div>
</div>
{/if}

<!-- class:resizable={type==='user'} -->
<div
    id={map_id}
    class:cursor-crosshair={type === 'add'}
    class:map={type !== 'usermap' && type !== 'add'}
    class:map_loading
    style={style}
>

        <div id="small-overlay" aria-hidden="true" onclick={onclickSmallOverlay}></div><!-- bulma WTF: content -->
</div>


<svelte:document
    onclick={onclickOutsideContextMenu}
    oncontextmenu={() => contextMenu.display = false}
/>

<style>

.dropdown-item.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 1rem;
}

.dropdown-item.is-disabled {
    cursor: default; /* Makes it behave like pointer-events: none */
}


.dropdown-item.is-disabled:hover {
    background-color: unset !important;
    color: unset !important;
}

.checkmark {
    margin-left: auto; /* Push it to the right */
    top: 1px;
}

    /*
.user-map {
    //min-height: 60vh;
    height: 50vh;
    max-height: min(650px,66vw) !important;
    max-width: 1100px;
}

.map {
    //min-height: 60vh;
    height: 50vh;
    max-height: min(650px,66vw) !important;
    max-width: 1100px;
}*/

/*
.resizable {
  resize: vertical;
  overflow: auto;
}
*/

:global(.cursor-crosshair canvas) {
    cursor: crosshair !important;
}


.context-menu {
    height: 100px;
    width: max-content;
    z-index: 3;
    position: absolute;
    display: block;
}


/*@media screen and (max-width: 768px) {
    :global(.mymap-add-map) {
        height: 70vw !important;
    }
}*/

#user {
    /*height: 35vw; /*55*/
    /*position: absolute;
    left: 0px;
    top: 0px;*/
    width: 100%;
    /*height: min(66vh,80vw);*/
    /*height: min(66vh,90vw);*/
    height: 55vh;
    /*~max-height: 60vw;~*/
    max-height: 35rem;
    /*height: 50vh;
    max-height: min(650px,66vw) !important;*/

    /*z-index: -1;*/
}

@media screen and (max-width: 640px) {
    #user  {
        position: relative;
       /*top: auto;*/
        /*height: 45vh;*/
        height: 90vw;
        max-height: none;
        /*z-index: auto;*/
    }
}

#mymap-mobile  {
    /*height: 35vw; /*55*/
    position: relative;
    width: 100%;
    height: 100%;
    max-height: none;
    /*z-index: -1;*/
}


#mymap-add  {
    /*height: 35vw; /*55*/
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100vw;
    height: 100%;
    /*z-index: -1;*/
}

@media screen and (max-width: 640px) {
    #mymap-add  {
        position: relative;
       /*top: auto;*/
        /*height: 45vh;*/
        /*height: 80vw;*/
        height: 90vw;
        /*z-index: auto;*/
    }
}

.svg-icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    /*stroke-width: 1px;*/
    stroke: currentColor;
    fill: currentColor;
    position: relative;
    vertical-align: middle;
    /*top: -.125em;*/
    vertical-align: -.1em;
}

.dropdown-divider {
    margin-top: 0.25rem;  /* smaller than default 0.5rem */
}

</style>
 
